export default __webpack_public_path__ + "static/media/cardIconBottom.1ae27a3f.svg";